export default __webpack_public_path__ + "static/media/section_blue.c773438f.svg";